/**
 * The words on the admin Price receipt card (PriceReceiptCard.jsx), kept
 * apart from the component so they can be tested and shared.
 */

/** When receipts started (#275 went live). Trips booked before have none. */
export const RECEIPTS_STARTED_AT = '2026-10-28T21:10:00Z';

const plural = (n, one, many) => `${n} ${n === 1 ? one : many}`;

/** "2 adults, 1 child, 1 lap infant" from a search's traveler counts. */
export function travelerSummary(t) {
  if (!t || typeof t !== 'object') return '';
  const parts = [];
  if (t.adults) parts.push(plural(t.adults, 'adult', 'adults'));
  if (t.children) parts.push(plural(t.children, 'child', 'children'));
  if (t.infants_in_seat) parts.push(plural(t.infants_in_seat, 'infant in a seat', 'infants in a seat'));
  if (t.infants_on_lap) parts.push(plural(t.infants_on_lap, 'lap infant', 'lap infants'));
  return parts.join(', ');
}

/** The cart's searched travelers ({ adult: 2, child: 1 }) in the same words. */
export function searchedSummary(byType) {
  if (!byType || typeof byType !== 'object') return '';
  return travelerSummary({
    adults: Number(byType.adult) || 0,
    children: Number(byType.child) || 0,
    infants_in_seat: Number(byType.infant_with_seat) || 0,
    infants_on_lap: Number(byType.infant_without_seat) || 0,
  });
}

/** The closed row's line about travelers vs the fare. */
export function travelerLine(travelers) {
  if (!travelers || travelers.priced == null || travelers.on_booking == null) return { tone: 'neutral', text: 'Travelers priced: not recorded' };
  if (travelers.mismatch) {
    return { tone: 'warn', text: `${plural(travelers.on_booking, 'traveler', 'travelers')} on a fare priced for ${travelers.priced}` };
  }
  return { tone: 'ok', text: `Travelers match the fare (${travelers.on_booking} of ${travelers.priced})` };
}
